import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f68bd02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"padding":"0 12px 12px"} }
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "分钟", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "el-upload-list__item-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重置")

import { useRoute, useRouter } from "vue-router"
import { onMounted, reactive, ref } from "vue"
import type { ElForm } from "element-plus"
import { Plus, ZoomIn, Download, Delete } from "@element-plus/icons-vue"
import type { UploadFile } from "element-plus/es/components/upload/src/upload.type"
import {
  getAllProduction,
  uploadPoster,
  createNewAdv,
  editAdv,
  // getXuejieList,
  selectAdv,
	getFriendListV2
} from "../config/interface";
import { ElMessage } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const goBack = () => {
  router.push({
    path: "/qrCode",
  });
};
const isEdit = ref(false);
isEdit.value = Number(route.query.id) > 0 ? true : false;
const formSize = ref("");
const ruleFormRef = ref<FormInstance>();
const ruleForm = ref({
  advName: "",
  xuejieList: [],
  proId: 0,
  attachProId: "",
  lastTime: 30,
  timeLimit: false,
  bgUrl: "",
});

const rules = reactive({
  advName: [
    {
      required: true,
      message: "请输入活动名称",
      trigger: "blur",
    },
  ],
  xuejieList: [
    {
      required: true,
      message: "请选择学姐",
      trigger: "blur",
    },
  ],
  proId: [
    {
      required: true,
      message: "请选择产品",
      trigger: "blur",
    },
  ],
});
// 保存｜新建
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  if (!ruleForm.value.bgUrl){
    ElMessage.error('请上传图片');
    return;
  }
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        advName: ruleForm.value.advName,
        xuejieList: ruleForm.value.xuejieList,
        proId: ruleForm.value.proId,
        attachProId: ruleForm.value.attachProId,
        advId: Number(route.query.id),
        timeLimit: ruleForm.value.timeLimit ? 1 : 0,
        lastTime: ruleForm.value.lastTime,
        bgUrl: ruleForm.value.bgUrl,
      };
      isEdit.value
        ? editAdv(params).then((res) => {
            if (res.data.success) {
              ElMessage.success(res.data.msg);
              setTimeout(() => {
                router.push({ path: "/qrCode" });
              }, 2000);
            } else {
              ElMessage.error(res.data.msg);
            }
          })
        : createNewAdv(params).then((res) => {
            if (res.data.success) {
              ElMessage.success(res.data.msg);
              setTimeout(() => {
                router.push({ path: "/qrCode" });
              }, 2000);
            } else {
              ElMessage.error(res.data.msg);
            }
          });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
const beforeAvatarUpload = () => {
  if (fileList.value.length > 0) {
    ElMessage.error("请先删除图片");
    return false;
  }
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  fileList.value = [];
};
const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const disabled = ref(false);

const handleRemove = () => {
  ruleForm.value.bgUrl = "";
  fileList.value = [];
};
const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!;
  dialogVisible.value = true;
};
const handleDownload = (file: UploadFile) => {
  window.open(file.url);
};
const fileList = ref([
  {
    name: "",
    url: "",
  },
]);
const uploadSectionFile = (file: any) => {
  const form = new FormData();
  form.append("file", file.file);
  uploadPoster(form).then((res) => {
    if (res.data.success) {
      ruleForm.value.bgUrl = res.data.data;
      ElMessage.success("上传成功");
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
const productList = ref([
  {
    id: "",
    proName: "",
  },
]);
const xuejieList = ref([
  {
    id: "",
    xjName: "",
    xjNickname: "",
    wxid: 0,
    nickname:"",
    name:''
  },
]);
//选择学姐
const checkedXuejieList = ref();
const changeXuejieList = () => {
  checkedXuejieList.value = xuejieList.value.filter((v) => {
    return ruleForm.value.xuejieList.includes(v.wxid);
  });
};
//删除学姐
const delXuejie = (index: number) => {
  ruleForm.value.xuejieList.splice(index, 1);
  changeXuejieList();
};

//生命周期
onMounted(() => {
  //获取全部产品
  getAllProduction({}).then((res) => {
    productList.value = res.data.data;
  });
  //获取学姐列表
  getFriendListV2({}).then((res) => {
    xuejieList.value = res.data.data;
  });
  if (isEdit.value) {
    let params = {
      aId: Number(route.query.id),
    };
    selectAdv(params).then((res) => {
      ruleForm.value = res.data.data;
      ruleForm.value.timeLimit = res.data.data.timeLimit == 1 ? true : false;
      fileList.value[0].name = res.data.data.advName;
      fileList.value[0].url = res.data.data.bgUrl;
      changeXuejieList()
    });
  } else {
    fileList.value = [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      class: "header",
      title: "返回",
      content: isEdit.value ? '编辑活动' : '新建活动',
      onBack: goBack
    }, null, 8, ["content"]),
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: ruleForm.value,
      rules: _unref(rules),
      "label-width": "160px",
      class: "demo-ruleForm",
      size: formSize.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "活动名称",
          prop: "advName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.advName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.advName) = $event)),
              style: {"width":"240px"},
              placeholder: "活动名称",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "选择学姐",
          prop: "xuejieList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.xuejieList,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.xuejieList) = $event)),
              multiple: "",
              placeholder: "选择学姐",
              style: {"width":"240px"},
              filterable: "",
              clearable: "",
              onChange: changeXuejieList
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xuejieList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    value: item.wxid,
                    label: item.nickname + '(' + item.name + ')'
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "学姐二维码" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkedXuejieList.value, (o, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"margin":"0 10px 10px 0"}
              }, [
                _createVNode(_component_el_card, { "body-style": { padding: '0px', height: '280px' } }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: o.qrcodeUrl,
                      class: "image",
                      alt: "学姐头像显示异常，请联系陈潇",
                      style: {"width":"200px","height":"200px"}
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(o.nickname) + " - " + _toDisplayString(o.name), 1),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          class: "button",
                          type: "danger",
                          icon: _unref(Delete),
                          size: "small",
                          circle: "",
                          onClick: ($event: any) => (delXuejie(index))
                        }, null, 8, ["icon", "onClick"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "选择产品",
          prop: "proId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.proId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.proId) = $event)),
              placeholder: "选择产品",
              style: {"width":"240px"},
              filterable: "",
              clearable: "",
              disabled: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    value: item.id,
                    label: item.proName
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "搭配其他产品广告",
          prop: "attachProId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.attachProId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.value.attachProId) = $event)),
              placeholder: "搭配其他产品广告",
              style: {"width":"240px"},
              multiple: "",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    value: item.id,
                    label: item.proName
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "限时优惠",
          prop: "timeLimit",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: ruleForm.value.timeLimit,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.value.timeLimit) = $event)),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "限时优惠时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: ruleForm.value.lastTime,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.value.lastTime) = $event)),
              min: 1,
              clearable: ""
            }, null, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "上传海报",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "http-request": uploadSectionFile,
              "file-list": fileList.value,
              "before-upload": beforeAvatarUpload
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              file: _withCtx(({ file }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: "图片"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("span", _hoisted_7, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ZoomIn))
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_8),
                    (!disabled.value)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (handleDownload(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Download))
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (!disabled.value)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "el-upload-list__item-delete",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (handleRemove()))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Delete))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["file-list"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dialog, {
              modelValue: dialogVisible.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: dialogImageUrl.value,
                  alt: "图片",
                  style: {"max-height":"100%","max-width":"100%"}
                }, null, 8, _hoisted_10)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (isEdit.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })),
            _createVNode(_component_el_button, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (resetForm(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules", "size"])
  ]))
}
}

})